import { c as _c } from "react/compiler-runtime";
import { captureException } from '@sentry/nextjs';
import { useMutation } from '@tanstack/react-query';
import ky from 'ky';
import { useState } from 'react';
import { API_ROUTES } from '@/constants';
import type { CreateSessionResponse, InitialProfile } from '../_utils/profile';
export interface CreateSessionPayload {
  user_id?: string;
  initial_profile?: InitialProfile;
}
export const useChatSession = () => {
  const $ = _c(5);
  const [sessionId, setSessionId] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp,
      onSuccess: data => {
        if (data.session_id) {
          setSessionId(data.session_id);
        }
      },
      onError: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const createSessionMutation = useMutation(t0);
  let t1;
  if ($[1] !== createSessionMutation.isPending || $[2] !== createSessionMutation.mutate || $[3] !== sessionId) {
    t1 = {
      sessionId,
      createSession: createSessionMutation.mutate,
      isCreatingSession: createSessionMutation.isPending
    };
    $[1] = createSessionMutation.isPending;
    $[2] = createSessionMutation.mutate;
    $[3] = sessionId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(payload) {
  return ky.post(API_ROUTES.WELLO_AGENT_SESSIONS.pathname, {
    json: payload ?? {}
  }).json();
}
function _temp2(error) {
  captureException(error);
}